<template>
    <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Assign Trader</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-12  ">
                            <label for="inputEmail4">Trader</label>
                            <multiselect 
                                v-model="filterTrader" 
                                placeholder="Select trader" 
                                label="firstName" 
                                track-by="traderId"
                                :options="traderList"  
                                :multiple="false" 
                                :limit="3"  ></multiselect>
                        </div>  
                    </div>
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <p v-if="errors.length">
                        <ul>
                        <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </p>
                    <div class="modal-footer bid">
                        <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                        <button type="button" class="btn btn-primary" @click="assignTrade()">Assign Trader</button>
                    </div>
              </form>
            </div>
          </div>
        </div>
    </div>
</template>
    <script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'pltraderadd',
        components :{
            
        },
        props: ['tradeData'],
        data() {
            return {
                loading : false,
                errors: [],
                traderList:[],
                filterTrader : {}

            };
        },
        methods: {   
        assignTrade(){
            this.loading = true;
            console.log(this.tradeData)
            var addData = { 
                tradeId: this.tradeData.id , 
                type : this.tradeData.type,
                traderId : this.filterTrader.traderId,
            };
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .post(config.baseUrlBidSide + "/pnl/set-trade-trader", addData, auth)
            .then(() => {
                this.loading = false;              
                this.$emit('close');               
            })
            .catch(() => {
                this.loading = false;              
            });
        },
        getTraderList(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
                .get(
                config.baseUrlBidSide +
                    "/pnl/trader-list?page=1&size=100&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group="+this.tenantName+"-Trader",
                    auth
                )
                .then(result => {
                    this.traderList = result.data.content.filter((e) => {return e.traderId != null});
                    let self = this;
                    this.traderList.forEach(element => {
                        console.log(self.tradeData.traderId ,element.id)
                        if(self.tradeData.traderId  == element.id){
                            self.filterTrader = element;
                        }
                    });
                    this.loading = false;


                })
                .catch(e => {
                console.log(e);
                });
        },
            

        },
        mounted(){
            this.getTraderList();
        }
    };
    </script>